<template>
  <button :style="{...styles.base,...backgroundImageStyle}"
          :class="getCss('link-style')" @click="handleClick"></button>
</template>
<script>
import '@tencent/ceiba-base-components/index.scss';
import { common, componentBaseMixin } from '@tencent/ceiba-base-components';
let  msdkiOSHandler;
export default {
  name: 'CTgclubLink',
  mixins: [componentBaseMixin],
  data() {
    return {
      cssPrefix: 'Tgclub-link-',
    };
  },
  computed: {
    backgroundImageStyle() {
      return {
        backgroundImage: this.configurationData.bgImage ? `url(${this.configurationData.bgImage})` : 'none',
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
      };
    },
    isApp() {
      return  this.$ast.isAPP();
    },
    isIos() {
      return  this.$platform.isIos;
    },
    isAndroid() {
      return  this.$platform.isAndroid;
    },
  },
  async mounted() {
    console.log('CTgclubLink configurationData=', this.configurationData);
    await this.initialize();
  },
  methods: {
    async initialize() {
      let { jumpType = 1 } = this.configurationData;
      jumpType  = parseInt(jumpType, 10);
      if (jumpType === 5) {
        this.initLoadAppFromGame();
      }
    },

    // 如果在ios，app外跳转，延迟一定时间后弹提示
    checkIosJumpShowInfo() {
      if (this.isIos
        && !this.isApp
        && this.configurationData.showInfoTime
        && this.configurationData.iosJumpInfo) {
        const showInfoTimeSecond = this.configurationData.showInfoTime * 1000;
        setTimeout(() => {
          this.$alert(this.configurationData.iosJumpInfo);
        }, showInfoTimeSecond);
      }
    },

    checkLimitJumpByDevice(limitIosJumpText, limitAndroidJumpText) {
      if (this.isIos && limitIosJumpText) {
        this.$alert({ msg: limitIosJumpText });
        return false;
      }
      if (this.isAndroid && limitAndroidJumpText) {
        this.$alert({ msg: limitAndroidJumpText });
        return false;
      }
      return true;
    },
    checkJumpTime(startJumpTime, msg) {
      const getTimeStamp = function (time) {
        if (time) {
          // ios 的时间格式需要更改一下
          // eslint-disable-next-line no-param-reassign
          time = time.replace(/-/g, '/');
          return parseInt(new Date(time).getTime() / 1000, 10);
        }
        return parseInt(new Date().getTime() / 1000, 10);
      };
      if (startJumpTime && msg && getTimeStamp() <= getTimeStamp(startJumpTime)) {
        this.$alert({ msg });
        return false;
      }
      return  true;
    },
    confirmFunc(androidConfirmText, iosConfirmText) {
      if (this.isIos && iosConfirmText) {
        return window.confirm(iosConfirmText);
      }
      if (this.isAndroid && androidConfirmText) {
        return window.confirm(iosConfirmText);
      }
      return  false;
    },
    handleClick() {
      this.handleClickEvent(); // 普通点击事件
      this.configurationData.jumpType = parseInt(this.configurationData.jumpType, 10) || 1;
      // 1 拉起App内点击在跳转 2 拉起App内直接跳转  3 h5直接跳转 4 跳转手机浏览器下载apk
      const { startJumpTime, msg, jumpType = 1, link, androidConfirmText, iosConfirmText,
        limitAndroidJumpText, limitIosJumpText  } = this.configurationData;
      if (!link) {
        console.error('link empty', link);
        return;
      }
      const jump = link => window.location.href = link;
      this.checkIosJumpShowInfo();
      if (jumpType === 1 || jumpType === 2) {
        if (!this.isApp) {
          return  this.$ast.gotoAPP(jumpType === 2 ? link : null);
        }
        if (!this.checkJumpTime(startJumpTime, msg))    return;
        if (!this.checkLimitJumpByDevice(limitIosJumpText, limitAndroidJumpText)) return  false;
        if (this.confirmFunc(androidConfirmText, iosConfirmText)) return  false;
        jump(link);
        return;
      }

      if (jumpType === 3) {
        if (!this.checkJumpTime(startJumpTime, msg))    return;
        if (!this.checkLimitJumpByDevice(limitIosJumpText, limitAndroidJumpText)) return  false;
        if (this.confirmFunc(androidConfirmText, iosConfirmText)) return  false;
        jump(link);
        return;
      }
      if (jumpType === 4) {
        if (!this.checkJumpTime(startJumpTime, msg))    return;
        if (!this.checkLimitJumpByDevice(limitIosJumpText, limitAndroidJumpText)) return  false;
        if (this.confirmFunc(androidConfirmText, iosConfirmText)) return  false;
        const iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.src = link;
        document.getElementsByTagName('body')[0].appendChild(iframe);
        return;
      }
      // 从游戏类跳转到心悦app
      if (jumpType === 5) {
        if (!this.checkJumpTime(startJumpTime, msg))    return;
        if (!this.checkLimitJumpByDevice(limitIosJumpText, limitAndroidJumpText)) return  false;
        if (this.confirmFunc(androidConfirmText, iosConfirmText)) return  false;
        const  jumpToApp = (url) => {
          setTimeout(() => {
            const iframe = document.createElement('iframe');
            iframe.src = `mqqapi://forward/url?version=1&src_type=web&url_prefix=${common.Base64.encode(url)}`;
            iframe.style.display = 'none';
            document.body.appendChild(iframe);
          }, 500);
        };
        if (/ipad|iphone|ipod/ig.test(navigator.userAgent.toLowerCase())) {
          console.log('OpenURLInSafiri msdkiOSHandler', msdkiOSHandler);
          if (typeof msdkiOSHandler === 'function') {
            msdkiOSHandler('OpenURLInSafiri', `tgclub://redirect?url=${link}`, (response) => {
              console.log('OpenURLInSafiri', response);
            });
          } else {
            jumpToApp(link);
          }
        } else {
          this.$ast.gotoAPP(link);
        }
        return;
      }
    },
    // 初始化  https://img.ssl.msdk.qq.com/wiki/msdkJsAdapter.js
    initLoadAppFromGame() {
      let uniqueId = 1;
      const observers = [];
      const  log = (message, data) => {
        const log = document.getElementById('log');
        const el = document.createElement('div');
        el.className = 'logLine';
        // eslint-disable-next-line no-plusplus
        el.innerHTML = `${uniqueId++}. ${message}:<br/>${JSON.stringify(data)}`;
        if (log && log.children && log.children.length) {
          log.insertBefore(el, log.children[0]);
        } else if (log) {
          log.appendChild(el);
        } else {
          //
        }
      };
      const   msdkNativeCallback  = (data) => {
        for (let i = 0; i < observers.length; i++) {
          const observer = observers[i];
          if (typeof observer !== 'undefined' && observer instanceof Function) {
            observer(data);
          }
        }
      };
      const  connectWebViewJavascriptBridge = (callback) => {
        if (window.WebViewJavascriptBridge) {
          callback(window.WebViewJavascriptBridge);
        } else {
          document.addEventListener('WebViewJavascriptBridgeReady', () => {
            callback(window.WebViewJavascriptBridge);
          }, false);
        }
      };

      connectWebViewJavascriptBridge((bridge) => {
        bridge.init((message, responseCallback) => {
          log('JS got a message', message);
          const data = {
            'Javascript Responds': 'Wee!',
          };
          log('JS responding with', data);
          responseCallback(data);
        });
        bridge.registerHandler('msdkNativeCallback', (data) => {
          msdkNativeCallback(data);
        });
        msdkiOSHandler = bridge.callHandler;
      });
    },
  },
};
</script>
<style lang="scss">
@import './styles.scss';
</style>
